<template>
  <div>

    <b-modal id="upload-excel-file" title="Upload Excel File" hide-footer centered>
      <b-form class="mt-2 mb-2" style="text-align: left;" @submit.prevent="addEmail">
        <b-form-group label="Add Email:" description="Consultant email associated with the record, must end in advancingecoag.com">
          <b-input type="text" v-model="emailToAdd"></b-input>
        </b-form-group>
        <b-button type="submit" size="sm" variant="success">add email</b-button>
      </b-form>

      <b-list-group >
        <b-list-group-item v-for="email of emails" :key="email">{{ email }}
          <b-icon-trash @click="removeEmail(email)" class="icon"></b-icon-trash>
        </b-list-group-item>
      </b-list-group>

      <b-form style="text-align: left;" @submit.prevent="processFile">

        <b-form-group label="Select Lab:">
          <b-select required :options="['chl', 'apical', 'haney']" v-model="lab"></b-select>
        </b-form-group>

        <b-form-group label="Select an excel file:">
          <b-form-file
            accept="application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
            v-model="file"
            placeholder="Choose a file or drop it here..."
            drop-placeholder="Drop file here..."
            required
          ></b-form-file>
        </b-form-group>

        <b-button type="submit">Upload</b-button>
      </b-form>
    </b-modal>
  </div>
</template>

<script>
import axios from "axios";
import { mapActions } from "vuex";
import XLSX from "xlsx";
import { search } from "../modules/api";
import { BIconTrash } from "bootstrap-vue";

export default {
  name: "upload-file",
  components: {
    BIconTrash
  },
  data() {
    return {
      file: null,
      lab: "",
      emailToAdd: "",
      emails: []
    };
  },
  methods: {
    addEmail() {
      this.emails.push(this.emailToAdd);
    },
    removeEmail(email) {
      this.emails = this.emails.filter(x => x != email);
    },
    async processFile() {

      if (this.emails.length <= 0) {
        return this.notify({
          message: "at least one email is required",
          variant: "error"
        });
      }

      const text = await this.file.arrayBuffer();
      const workbook = XLSX.read(text, {type: "array"});
      const sheetName = workbook.SheetNames[0];
      let worksheet = workbook.Sheets[sheetName];
      let json = XLSX.utils.sheet_to_json(worksheet);

      const sampleNumbers = json.map(x => x.sampleNumber).filter(x => x);
      if (sampleNumbers.length <= 0) {
        return;
      }

      let res = await search.sampleNumber(sampleNumbers);
      if (res.data.success) {
        let existing = res.data.orders.map(x => x.sampleNumber);
        if (existing.length > 0) {
          this.notify({
            message: `${existing.length} records already exist, these records will be skipped.`
          });
        }
        json = json.filter(x => !existing.includes(x.sampleNumber));
        if (json.length <= 0) {
          return;
        }
      } else if (res.data.message != "failed to find results") {  
        return;
      }


      const processed = {
        records: []
      };

      const elmts = ["sugar", "pH", "EC", "potassium", "calcium", "magnesium", "sodium", "ammonium" , "NO3_nitrate", "nitrogen_in_nitrate", "nitrogen", "chloride", "sulfur", "phosphorous", "silica", "iron", "manganese" , "zinc", "boron", "copper", "molybdenum", "aluminum", "cobalt"];
      const nameMap = {
        sugar: "sugar %",
        pH: "pH NA",
        EC: "EC mS/cm",
        potassium: "potassium ppm",
        calcium: "calcium ppm",
        magnesium: "magnesium ppm",
        sodium: "sodium ppm",
        ammonium: "ammonium ppm",
        NO3_nitrate: "NO3_nitrate ppm",
        nitrogen_in_nitrate: "nitrogen_in_nitrate ppm",
        nitrogen: "nitrogen ppm",
        chloride: "chloride ppm",
        sulfur: "sulfur ppm",
        phosphorous: "phosphorous ppm",
        silica: "silica ppm",
        iron: "iron ppm",
        manganese: "manganese ppm",
        zinc: "zinc ppm",
        boron: "boron ppm",
        copper: "copper ppm",
        molybdenum: "molybdenum ppm",
        aluminum: "aluminium ppm",
        cobalt: "cobalt ppm"
      };

      for (let row of json) {

        if (!row.sampleDate) {
          continue;
        }
        
        let date = new Date(row.sampleDate);
        if (typeof row.sampleDate === "number") {
          date = this.excelDateToJSDate(row.sampleDate);
        }

        const record = {
          meta: {
            sampleNumber: row.sampleNumber ? typeof row.sampleNumber === "string" ? row.sampleNumber.trim() : row.sampleNumber : "",
            barcode: row.barcode ? row.barcode.trim() : "",
            sampleDate: date.toISOString().slice(0, 10),
            name: row.businessName,
            remarks: row.remarks || ""
          },
          tmpMeta: {
            location: row.locationName,
            plantPart: row.plantPart,
            emails: this.emails,
            plot: row.plotName,
            crop: row.cropName,
            variety: row.varietyName,
            sampleType: row.sampleType,
            rawUuid: null,
            uploadTimestamp: new Date(),
            lab: this.lab
          },
          values : []
        };

        for (let elmt of elmts) {
          let splitName = nameMap[elmt];
          splitName = splitName.split(" ");
          let name = splitName.slice(0, splitName.length - 1).join(" ");
          record.values.push({
            name,
            value: parseFloat(row[elmt] || 0),
            units: splitName[splitName.length - 1]
          });
        }

        processed.records.push(record);
    
      }
      
      let ok = await axios.post("https://chl-email-service.herokuapp.com/api/samples", processed, {
        headers: {
          Authorization: localStorage.CHLToken
        }
      });

      this.$bvModal.hide("upload-excel-file");

      this.notify({
        message: ok.data.message,
        variant: ok.data.success ? "success" : "warn"
      });
    },
    excelDateToJSDate(serial) {
      var utc_days  = Math.floor(serial - 25569);
      var utc_value = utc_days * 86400;                                        
      var date_info = new Date(utc_value * 1000);

      var fractional_day = serial - Math.floor(serial) + 0.0000001;

      var total_seconds = Math.floor(86400 * fractional_day);

      var seconds = total_seconds % 60;

      total_seconds -= seconds;

      var hours = Math.floor(total_seconds / (60 * 60));
      var minutes = Math.floor(total_seconds / 60) % 60;

      return new Date(date_info.getFullYear(), date_info.getMonth(), date_info.getDate() + 1, hours, minutes, seconds);
    },
    ...mapActions(["notify"])
  }
};
</script>

<style lang="scss" scoped>

.icon {
  cursor: pointer;
}

</style>
